@if (logbuchLoading()) {
  <clr-spinner class="centred" />
} @else if (logbuch()) {
  <div class="clr-row w-100-p nxm">
    @if (authService?.token?.rights?.status > 2) {
      <div class="dokumenteControls btn-group btn-primary btn-sm padding-10-t wrap-button set-width">
        @if (id == -1) {
          <button type="button" class="btn" (click)="addEintrag()">
            <cds-icon shape="plus" />
            {{ 'Neu' | mrTranslate }}
          </button>
        }
        @if (id == 0) {
          <button type="button" class="btn" (click)="cancel()">
            <cds-icon shape="times" />
            {{ 'Abbrechen' | mrTranslate }}
          </button>
          <button type="button" class="btn btn-success" (click)="speichern()">
            <cds-icon shape="plus" />
            {{ 'Speichern' | mrTranslate }}
          </button>
        }
        @if (selectedRow() && authService?.token?.rights?.status > 5) {
          <button type="button" class="btn btn-danger" (click)="loeschen()">
            <cds-icon shape="times" />
            {{ 'Löschen' | mrTranslate }}
          </button>
        }
      </div>
    }
    @if (id == 0) {
      <form clrForm class="clr-col-12 width100">
        <clr-select-container>
          <label>{{ 'Wichtigkeit' | mrTranslate }}</label>
          <select clrSelect [(ngModel)]="neuesLevel" name="level">
            <option value="0">{{ 'niedrig' | mrTranslate }}</option>
            <option value="1">{{ 'hoch' | mrTranslate }}</option>
          </select>
        </clr-select-container>
        <clr-textarea-container>
          <label>{{ 'Text' | mrTranslate }}</label>
          <textarea
            clrTextarea
            [(ngModel)]="neuerText"
            name="text"
            rows="3"
            [placeholder]="'Log-Eintrag eingeben...' | mrTranslate"></textarea>
        </clr-textarea-container>
      </form>
    }
    @if (logbuch().rows?.length) {
      <clr-datagrid
        class="datagrid-compact clr-col-12"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedRow()]"
        (clrDgSelectedChange)="selectedRow.set($event[0])"
        [clrDgItemsIdentityFn]="row => row?.id">
        @for (column of logbuch().columns; track column.id) {
          <clr-dg-column>
            <ng-container
              *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['kostentyp', 'kostenid', 'export', 'task'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <clr-dg-row *clrDgItems="let row of logbuch().rows" [clrDgItem]="row">
          <clr-dg-row-detail *clrIfExpanded [clrDgReplace]="false">
            <pre class="padding-5">{{ row['text'] }}</pre>
          </clr-dg-row-detail>
          @for (cell of logbuch().columns; track cell.id) {
            @if (cell.id.toLowerCase() == 'ic') {
              <clr-dg-cell>
                <cds-icon
                  size="28"
                  [shape]="row[cell.id] == 1 ? 'exclamation-circle' : 'info-circle'"
                  [style.color]="row[cell.id] == 1 ? 'red' : 'green'" />
              </clr-dg-cell>
            } @else {
              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
            }
          }
        </clr-dg-row>

        <clr-dg-footer></clr-dg-footer>
      </clr-datagrid>
    }
  </div>
}
